import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Typography,
  TextField,
  Avatar,
  Grid
} from '@material-ui/core';
import Button from 'components/shared/Button';

const Messages = ({ messages = [], onSendMessage, applicantId, getMessages, clientId }) => {
  const [messageText, setMessageText] = useState('');
  const [loading, setLoading] = useState(false);

  // Load messages when component mounts
  useEffect(() => {
    if (applicantId && getMessages) {
      getMessages(applicantId, clientId);
    }
  }, [applicantId, getMessages]);

  const handleSendMessage = async () => {
    if (messageText.trim() && !loading) {
      setLoading(true);
      try {
        await onSendMessage(messageText.trim(), clientId);
        setMessageText('');
      } catch (error) {
        console.error('Error sending message:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  const displayMessages = messages.length > 0 ? messages : [
  ];

  return (
    <Box sx={{ p: 3 }}>
        {/* Header Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 1 }}>
            Messages
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Correspond with applicants here.
          </Typography>
        </Box>

        {/* Message Input Section */}
        <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
          <Grid item xs={10}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Message"
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              onKeyPress={handleKeyPress}
              size="small"
            />
          </Grid>
          <Grid item xs={2}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSendMessage}
              disabled={!messageText.trim() || loading}
              loading={loading}
              style={{
                borderRadius: 20,
                textTransform: 'none',
                fontWeight: 'bold',
                padding: '4px 16px'
              }}
            >
              {loading ? 'SENDING...' : 'SEND MESSAGE'}
            </Button>
          </Grid>
        </Grid>

        {/* Messages List */}
        <Box>
          {displayMessages.map((message, index) => (
            <Box key={message.id || message.uuid || index} sx={{ mb: 2 }}>
              <Grid container alignItems="flex-start" spacing={2}>
                {/* Avatar */}
                <Grid item>
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      bgcolor: 'primary.main',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    {message.initials || (message.username || message.senderName || 'User').substring(0, 2).toUpperCase()}
                  </Avatar>
                </Grid>

                {/* Message Card */}
                <Grid item xs>
                  <Card
                    style={{
                      padding: "1rem",
                      borderRadius: 8,
                      boxShadow: 1,
                      backgroundColor: 'var(--bg-surface)'
                    }}
                  >
                    <Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                          {message.username || message.senderName || 'User'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {new Date(message.createdAt || message.date).toLocaleDateString('en-GB')}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        {message.message || message.text}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>

        {/* Empty State */}
        {messages.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 2, mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              No messages yet.
            </Typography>
          </Box>
        )}
    </Box>
  );
};

export default Messages;
